/**
 * shared/src/schemas/garage.schema.ts
 *
 * Shared DTO schemas for Garage (motorcycle management).
 */
import { z } from 'zod';
export const BikeSchema = z.object({
    id: z.string().uuid(),
    user_id: z.string().uuid(),
    brand: z.string().min(1).max(100),
    model: z.string().min(1).max(100),
    year: z.number().int().min(1900).max(2100).optional(),
    nickname: z.string().max(100).optional(),
    plate: z.string().max(20).optional(),
    vin: z.string().max(50).optional(),
    photo_url: z.string().url().nullable().optional(),
    total_km: z.number().nonnegative().optional(),
    created_at: z.string().datetime().optional(),
    updated_at: z.string().datetime().optional(),
}).passthrough();
export const CreateBikeInputSchema = z.object({
    brand: z.string().min(1).max(100),
    model: z.string().min(1).max(100),
    year: z.number().int().min(1900).max(2100).optional(),
    nickname: z.string().max(100).optional(),
    plate: z.string().max(20).optional(),
    vin: z.string().max(50).optional(),
    total_km: z.number().nonnegative().optional(),
});
export const MaintenanceSchema = z.object({
    id: z.string().uuid(),
    bike_id: z.string().uuid(),
    type: z.string(),
    description: z.string().optional(),
    due_km: z.number().nonnegative().optional(),
    due_date: z.string().datetime().optional(),
    completed: z.boolean().optional().default(false),
    cost_cents: z.number().int().nonnegative().optional(),
}).passthrough();
//# sourceMappingURL=garage.schema.js.map